import { ReactNode } from 'react';

import { cx } from '@libs/classnames';
import { Loader } from '@ui/components/Loader';
import { PageComplexSubTitle } from '@ui/components/PageComplexSubTitle';
import { Tabs } from '@ui/components/Tabs';

import { ParticipantDto, ClockControlType, TournamentTeam } from '@features/shared/api/typings';
import { CardParticipantList } from '@features/shared/ui/CardParticipantList';

import styles from './TournamentParticipants.module.css';

type Sort = 'NumberAsc' | 'AlphabetAsc' | 'RatingDesc';

const TABS: { value: Sort; label: string; disabled?: boolean }[] = [
  { value: 'NumberAsc', label: 'По порядку' },
  { value: 'RatingDesc', label: 'По рейтингу' },
  { value: 'AlphabetAsc', label: 'По алфавиту' },
];

export type Props = {
  className?: string;
  isPending?: boolean;
  teams?: TournamentTeam[];
  participants?: ParticipantDto[];
  clockControl?: ClockControlType;
  onTabChange: (sort: Sort) => void;
  tab: Sort;
  isManager: boolean;
  highlightedUserId?: string;
  showNumberInTeam?: boolean;
  hideTitle?: boolean;
  groupTitle?: string;
  hideNumbers?: boolean;
  isRcf: boolean;
  renderShieldQuickPeek?: (userId: string) => ReactNode;
};
export function TournamentParticipants({
  className,
  isPending,
  teams,
  participants,
  clockControl,
  onTabChange,
  tab,
  isManager,
  highlightedUserId,
  showNumberInTeam,
  hideTitle,
  groupTitle,
  hideNumbers,
  isRcf,
  renderShieldQuickPeek,
}: Props) {
  return (
    <div className={cx(className, styles.participantsWidget)}>
      {!hideTitle && (
        <PageComplexSubTitle
          className={styles.title}
          title="Участники"
          filters={
            <Tabs
              tabs={TABS}
              value={tab}
              tabClassName={styles.tabItem}
              flat
              onChange={onTabChange}
            />
          }
        />
      )}

      {isPending || !clockControl ? (
        <Loader className={styles.loader} centered />
      ) : (
        <CardParticipantList
          className={styles.participants}
          hideNumbers={hideNumbers}
          participants={participants}
          teams={teams?.map((t) => ({ id: t.teamId, name: t.name }))}
          clockControl={clockControl}
          highlightedUserId={highlightedUserId}
          showEmails={isManager}
          showNumberInTeam={showNumberInTeam}
          groupTitle={groupTitle}
          isRcf={isRcf}
          renderShieldQuickPeek={renderShieldQuickPeek}
        />
      )}
    </div>
  );
}
